(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-read-more"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener('DOMContentLoaded', () => {
    const readMoreLink = document.getElementById('n-readMoreLink');
    const longText = document.getElementById("n-span");
    const textContent = document.getElementById('n-initialText');

    readMoreLink.addEventListener('click', (event) => {
        event.preventDefault(); 
        
        if (textContent.style.display === "none") {
            textContent.style.display = "inline";
            longText.style.display = "none";
            readMoreLink.textContent = 'Read More';
        } else {
            textContent.style.display = "none";
            longText.style.display = "inline";
            readMoreLink.textContent = 'Read Less';
        }
    });
});

  } catch(e) { console.error(e); }
})();
})();
